import React from "react";
import Accordion from "react-bootstrap/Accordion";
import PaginationModified from "../../data/PaginationModified";
import { convertThenFormat, formatDateTimezon } from "../common-data/Converts";

const UPTMListingsMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const planStatus = row?.current_subscription_status
            ?.replace(/ /g, "_")
            ?.toLowerCase();

          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="log-card-top">
                  <div
                    className="profile-name-number"
                    style={{
                      columnGap: "0",
                      height: "auto",
                    }}
                  >
                    <div className="name-number">
                      <h3 className="lead-name">{row?.user_name || "NA"}</h3>
                      <p className="number">{row?.user_mobile || "NA"}</p>
                      {row?.user_email ? (
                        <span className="value email semi-bold">
                          {row?.user_email || "NA"}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header style={{ padding: "0 10px 10px 10px" }}>
                        Show More
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value">
                            <span className="label">added by</span>
                            <span className="value">
                              {row?.upgraded_by_name || "NA"} <br />
                              <small className="lowercase underline">
                                {row?.upgraded_by_mobile || ""}
                                <br />
                                {row?.upgraded_by_email || ""}
                              </small>
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">gym name</span>
                            <span className="value">
                              {row?.gym_name || "NA"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">plan status</span>
                            <span
                              className="value"
                              style={{
                                background:
                                  planStatus === "active"
                                    ? "#379C00"
                                    : planStatus === "expiring"
                                    ? "#EB8317"
                                    : "#D90000",
                                color: "#fff",
                                padding: "5px",
                              }}
                            >
                              {row?.current_subscription_status || "NA"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">current addon</span>
                            <span className="value">
                              {row.current_plan_name || ""}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">sessions</span>
                            <span className="value">
                              {row?.n_session || 0}
                              {row?.session_duration
                                ? ` (${row.session_duration} days)`
                                : ""}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Start/Expire Date</span>
                            <span className="value">
                              <small className="gray underline">
                                {row?.date_added
                                  ? formatDateTimezon(row.date_added)
                                  : "-"}
                              </small>
                              <br />
                              {row?.start_date
                                ? formatDateTimezon(row.start_date)
                                : "-"}
                              <br />
                              {row?.expire_date
                                ? formatDateTimezon(row.expire_date)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Payment Type</span>
                            <span
                              className={`value ${
                                row?.is_partial ? "link" : ""
                              }`}
                              onClick={() =>
                                row?.is_partial
                                  ? setModValues((prevs) => ({
                                      ...prevs,
                                      isModOpen: true,
                                      cardName: "partial_details",
                                      partialDetails:
                                        row?.payment_details || [],
                                    }))
                                  : null
                              }
                            >
                              {row?.is_partial ? "Partial" : "Full"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Total Amount</span>
                            <span className="value">
                              ₹{convertThenFormat(row?.price || 0)}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Partial Amount</span>
                            <span className="value">
                              {row?.is_partial
                                ? `₹${convertThenFormat(
                                    row?.total_partial_price || 0
                                  )}`
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Online/Cash Amount</span>
                            <span className={`value`}>
                              <small>
                                ₹
                                {convertThenFormat(
                                  row?.is_partial
                                    ? row?.partial_total_online
                                    : row?.total_online || 0
                                )}
                                / ₹
                                {convertThenFormat(
                                  row?.is_partial
                                    ? row?.partial_total_cash
                                    : row?.total_cash || 0
                                )}
                              </small>
                            </span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default UPTMListingsMobile;
